/* eslint-disable */
export default {
  start: 'クイックツアーに参加',
  skip: 'スキップ',
  next: '次へ',
  finish: '完了',
} as const;

// @key: @#@"start"@#@ @source: @#@"Take a quick tour"@#@
// @key: @#@"skip"@#@ @source: @#@"Skip"@#@
// @key: @#@"next"@#@ @source: @#@"Next"@#@
// @key: @#@"finish"@#@ @source: @#@"Finish"@#@
